import { schema } from 'normalizr'

const Company = new schema.Entity('Company')
const Companies = [Company]

export default {
	Company,
	Companies
}
